module.exports = __webpack_public_path__ + "f572638f/img/rename-icon.de4e673d.svg";